module.exports = __webpack_public_path__ + "static/US1_5P_traditional_v2-9a4ad31f71d7af3b8a467ee5bd8164e2.png";